import { StrictEqualityComparer } from "../../shared/index.js";
import { BasicAsyncEnumerable } from "../BasicAsyncEnumerable.js";
export const join = (outer, inner, outerKeySelector, innerKeySelector, resultSelector, comparer = StrictEqualityComparer) => {
    async function* iterator() {
        const innerArray = [];
        for await (const i of inner) {
            innerArray.push(i);
        }
        for await (const o of outer) {
            const outerKey = outerKeySelector(o);
            for (const i of innerArray) {
                const innerKey = innerKeySelector(i);
                if (comparer(outerKey, innerKey) === true) {
                    yield resultSelector(o, i);
                }
            }
        }
    }
    return new BasicAsyncEnumerable(iterator);
};
